import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import styled from 'styled-components';

import InputField from 'dashboard/components/FormControls/InputField';
import Button from 'design-system/components/Button';

const SaveButton = styled(Button)`
  width: 30%;
  min-width: 190px;
`;

const FormSamlMetadataUrlComponent = (props: InjectedFormProps<{}, {}>) => {
  const { pristine, submitting } = props;

  return (
    <form onSubmit={props.handleSubmit}>
      <Field
        name='metadataUrl'
        component={InputField}
        placeholder='https://dev-12345.okta.com/app/abcdefg/sso/saml/metadata'
        label='Provide a Metadata URL to retrieve the IdP details.'
      />
      <SaveButton type='submit' disabled={pristine || submitting} isPending={submitting}>
        Get metadata
      </SaveButton>
    </form>
  );
};

const FormSamlMetadataUrl = reduxForm<FormSamlMetadataUrlData, {}>({
  form: 'samlMetadataUrl',
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormSamlMetadataUrlComponent);

export interface FormSamlMetadataUrlData {
  metadataUrl: string;
}

export default FormSamlMetadataUrl;
